'use strict';

export const EVENTS = {
  CREATED: 'created',
  DESTROYED: 'destroyed',
  CLOSED: 'closed',
  MESSAGE_RECEIVED: 'messageReceived',
  MESSAGE_SENT: 'messageSent',
  CUSTOM_RECEIVED: 'customReceived',
  CONFIG_UPDATED: 'configUpdated',
  STATE_CHANGED: 'stateChanged',
  FIRST_TIME_USER: 'newUser',
};
export const LIFECYCLE_EVENTS = Object.values(EVENTS);

export const MODES = {
  FULLSCREEN: 'fullscreen',
  SIDEBAR: 'sidebar',
  POPUP: 'popup',
};
export const MESSENGER_MODES = Object.values(MODES);

export const ALLOWED_CONFIG_PROPS = [
  // 'Public' props
  'mode',
  'popupWidth',
  'popupHeight',
  'headerText',
  'customPromptMessage',
  'newChat',
  'color',
  'botIcon',
  'allowBackgroundScroll',
  'metadata',
  'externalUserId',
  'collectUserIpAddress',
  'disableAttachments',
  'enableRecording',
  'autoplayAudio',
  'disableInput',
  'historyLimit',
  'disableReset',
  'themeCssUrl',
  'customCssUrl',
  'themeName',
  'themeCssOnly',

  // 'Private' props
  'standalone',
  'botId',

  //Positioning
  'widgetPosition',
];

export const MESSAGES = {
  CONFIG: 'fxo-messenger-config',
  REQUEST_CONFIG: 'fxo-messenger-config-request',
  CLOSE: 'fxo-messenger-close',
  DESTROY: 'fxo-messenger-destroy',
  SEND_MESSAGE: 'fxo-messenger-send-message',
  STATE_UPDATE: 'fxo-messenger-state-change',
  MESSAGE_RECEIVED: 'fxo-messenger-message-received',
  MESSAGE_SENT: 'fxo-messenger-message-sent',
  CUSTOM_RECEIVED: 'fxo-messenger-custom-received',
  CONFIG_UPDATED: 'fxo-messenger-config-updated',
  VIEW_MODE_CHANGED: 'fxo-messenger-view-mode-updated',
  FIRST_TIME_USER: 'fxo-messenger-new-user',
  CLEAR_HISTORY: 'fxo-messenger-clear-history',
  FORGET_USER: 'fxo-forget-user',
};

export const THEME_BASE_URL = 'https://d2u2e8j2jrnyta.cloudfront.net';
export const THEME_DEFAULT = 'classic';



// WEBPACK FOOTER //
// ./src/messenger/lib/Constants.js